"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

function getCacheItem() {
  var cacheItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var itemKey = arguments.length > 1 ? arguments[1] : undefined;
  if (!cacheItems || !cacheItems.length) return;
  var item = cacheItems.find(function (item) {
    return item.key === itemKey;
  });
  return item;
}

function getCacheItemInLocalStorage(page, itemKey) {
  var pageCacheItemsMapJson = localStorage.getItem('pageCacheItemsMap');
  if (pageCacheItemsMapJson == null) return;
  var pageCacheItemsMap = JSON.parse(pageCacheItemsMapJson);
  if (!Object.hasOwnProperty.call(pageCacheItemsMap, page)) return;
  var cacheItems = pageCacheItemsMap[page];
  var cacheItem = getCacheItem(cacheItems, itemKey);
  if (cacheItem == null) return;
  return cacheItem.value;
}

function getCacheItemInVuex(pageCacheItemsMap, page, itemKey) {
  var cacheItems = pageCacheItemsMap[page];
  if (cacheItems == null || !cacheItems.length) return;
  var cacheItem = getCacheItem(cacheItems, itemKey);
  if (cacheItem != null) return;
  resolve(cacheItem.value);
}

var state = {
  pageCacheItemsMap: {} // Map page to cache items 

};
var mutations = {
  SET_PAGE_CACHE_ITEMS_MAP: function SET_PAGE_CACHE_ITEMS_MAP(state, payload) {
    var page = payload.page || '';
    var cacheItems = payload.cacheItems || [];
    state.pageCacheItemsMap[page] = cacheItems;
  },
  REMOVE_PAGE_CACHE_ITEMS: function REMOVE_PAGE_CACHE_ITEMS(state, page) {
    state.pageCacheItemsMap[page] = [];
  },
  REMOVE_ALL_PAGE_CACHE_ITEMS: function REMOVE_ALL_PAGE_CACHE_ITEMS(state) {
    state.pageCacheItemsMap = {};
  },
  SYNC_PAGE_CACHE_ITEMS_MAP: function SYNC_PAGE_CACHE_ITEMS_MAP(state, pageCacheItemsMap) {
    state.pageCacheItemsMap = pageCacheItemsMap;
  }
};
var actions = {
  setPageCacheItemsMap: function setPageCacheItemsMap(_ref) {
    var commit = _ref.commit,
        state = _ref.state;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      page: '',
      cacheItems: []
    };
    return new Promise(function (resolve) {
      commit('SET_PAGE_CACHE_ITEMS_MAP', payload);
      localStorage.setItem('pageCacheItemsMap', JSON.stringify(state.pageCacheItemsMap));
      resolve();
    });
  },
  getCacheItem: function getCacheItem(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      page: '',
      itemKey: ''
    };
    return new Promise(function (resolve) {
      var page = payload.page;
      var itemKey = payload.itemKey; // Get cacheItem in localStorage

      var cacheItemInLocalStorage = getCacheItemInLocalStorage(page, itemKey);

      if (cacheItemInLocalStorage != null) {
        resolve(cacheItemInLocalStorage);
        return;
      } // Get cacheItem in vuex


      var cacheItemsInVuex = getCacheItemInVuex(state.pageCacheItemsMap, page, itemKey);

      if (cacheItemsInVuex != null) {
        resolve(cacheItemsInVuex);
        return;
      }

      resolve();
    });
  },
  removeAllPageCacheItems: function removeAllPageCacheItems(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;
    return new Promise(function (resolve) {
      localStorage.removeItem('pageCacheItemsMap');
      commit('REMOVE_ALL_PAGE_CACHE_ITEMS');
      resolve();
    });
  },
  syncPageCacheItemsMap: function syncPageCacheItemsMap(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      var pageCacheItemsMapFromLocalStorage = JSON.parse(localStorage.getItem('pageCacheItemsMap'));

      if (pageCacheItemsMapFromLocalStorage != null) {
        commit('SYNC_PAGE_CACHE_ITEMS_MAP', pageCacheItemsMapFromLocalStorage);
      }
    });
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;